jQuery(document).ready(function($) {

  class CarInfoFinder {
    constructor() {
      this.$manufacturer     = $("#manufacturer");
      this.$model            = $("#model");
      this.$year             = $("#year");
      this.$dynamicList      = $("#dynamic-list");
      this.$dynamicListTitle = $("#dynamic-list-title");
      this.$content          = $("#carinfo-content");

      this.slug    = carinfo_ajax.vehicle_slug;
      this.siteUrl = carinfo_ajax.site_url;
      this.restUrl = carinfo_ajax.rest_url; // add to wp_localize_script
      this.nonce   = carinfo_ajax.rest_nonce; // add to wp_localize_script

      if ( !this.$manufacturer.length ) return;

      this.bindEvents();
    }

    // -------------------------------------------------------------------------
    // Utilities
    // -------------------------------------------------------------------------

    normalizeString(str) {
      return str.toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    }

    updateURL(manufacturer = null, model = null, year = null) {
      let url = `${this.siteUrl}${this.slug}/`;
      if (manufacturer) url += `${manufacturer}/`;
      if (model)        url += `${model}/`;
      if (year)         url += `${year}/`;
      window.history.pushState(null, "", url);
    }

    // -------------------------------------------------------------------------
    // REST fetch helpers
    // -------------------------------------------------------------------------

    async fetchRest(endpoint, params = {}) {
      const url = new URL(`${this.restUrl}axkid/v1/carinfo/${endpoint}`);
      Object.entries(params).forEach(([key, val]) => {
        if (val) url.searchParams.set(key, val);
      });

      try {
        const response = await fetch(url.toString(), {
          headers: {
            'X-WP-Nonce': this.nonce,
          },
        });

        if (!response.ok) {
          throw new Error(`REST error: ${response.status} ${response.statusText}`);
        }

        return await response.json();

      } catch (error) {
        console.error(`[CarInfoFinder] fetchRest(${endpoint}) failed:`, error);
        return null;
      }
    }

    // -------------------------------------------------------------------------
    // Dropdown population
    // -------------------------------------------------------------------------


    resetModels() {
      this.$model
        .empty()
        .append('<option value="">-- Select Model --</option>')
        .prop('disabled', true);
      this.resetYears();
    }

    resetYears() {
      this.$year
        .empty()
        .append('<option value="">-- Select Year --</option>')
        .prop('disabled', true);
    }

    // -------------------------------------------------------------------------
    // Fragment swap
    // -------------------------------------------------------------------------

    swapFragment(data) {
      if (!data) return;

         console.log(data);

         const fragment = data?.fragment ?? {};
         const options = data?.options ?? {};

      // Swap main content
         if (fragment?.content) {
        $('.vehicle-information').html(fragment.content);
      }

      // Swap dropdown options (keep placeholder, replace the rest)
      if (options?.model) {
        this.$model.empty().append(options.model);
        this.$model.prop('disabled', false);
      }

      if (options?.year) {
        this.$year.empty().append(options.year);
        this.$year.prop('disabled', false);
      }
    }

    // -------------------------------------------------------------------------
    // Dynamic list
    // -------------------------------------------------------------------------

    updateDynamicList(items, type) {
      if (!this.$dynamicList.length) return;

      this.$dynamicListTitle.text(
        type === "manufacturer"
          ? carinfo_ajax.available_manufacturers_text
          : carinfo_ajax.available_models_text
      );

      this.$dynamicList.empty();
      items.forEach((item) => {
        const itemSlug = this.normalizeString(item.name);
        const link = type === "manufacturer"
          ? `${this.siteUrl}${this.slug}/${itemSlug}/`
          : `${this.siteUrl}${this.slug}/${this.normalizeString(this.$manufacturer.val())}/${itemSlug}/`;
        this.$dynamicList.append(`<li><a href="${link}">${item.name}</a></li>`);
      });
    }

    async refreshDynamicList() {
      const manufacturerVal = this.$manufacturer.val();
      const modelVal        = this.$model.val();

      if (!manufacturerVal) {
        const data = await this.fetchRest('manufacturers');
        if (!data) return;
        const filtered = data.filter(
          (item) => !carinfo_ajax.excluded_manufacturers.includes(item.toLowerCase())
        );
        this.updateDynamicList(filtered.map(name => ({ name })), "manufacturer");
        return;
      }

      if (!modelVal) {
        const data = await this.fetchRest('models', { brand: manufacturerVal });
        if (!data) return;
        this.updateDynamicList(data.map(name => ({ name })), "model");
      }
    }

    // -------------------------------------------------------------------------
    // Event handlers
    // -------------------------------------------------------------------------

      async onManufacturerChange() {
         const val          = this.$manufacturer.val();
         const brand_name   = this.$manufacturer.find('option:selected').text();
         const manufacturerSlug = this.normalizeString(val);

         if (!val) {
            this.resetModels();
            this.updateURL();
            const data = await this.fetchRest('manufacturers');
            if (data) this.swapFragment(data);
            return;
         }

         this.resetModels();
         this.updateURL(manufacturerSlug);

         const data = await this.fetchRest('models', {
            brand:      manufacturerSlug,
            brand_name: brand_name,
         });

         if (!data) return;
         this.swapFragment(data, this.$model);
      }

      async onModelChange() {
         const modelVal         = this.$model.val();
         const manufacturerVal  = this.$manufacturer.val();
         const manufacturerSlug = this.normalizeString(manufacturerVal);

         if ( !modelVal ) {
            // Model deselected — revert to manufacturer URL
            this.resetYears();
            this.updateURL( manufacturerSlug );
            const data = await this.fetchRest( 'models', {
               brand:      manufacturerSlug,
               brand_name: this.$manufacturer.find('option:selected').text(),
            });
            if ( data ) this.swapFragment( data );
            return;
         }

         const modelSlug = this.normalizeString(
            this.$model.find("option:selected").text()
         );

         this.updateURL( manufacturerSlug, modelSlug );
         this.resetYears();

         const data = await this.fetchRest( 'years', {
            brand: manufacturerSlug,
            model: modelVal,
         });

         if ( !data ) return;

         this.swapFragment( data );
         this.$content.removeClass( 'is-loading' );
      }

    async onYearChange() {
      const year             = this.$year.val();
      const manufacturerVal  = this.$manufacturer.val();
      const modelVal         = this.$model.val();
      const manufacturerSlug = this.normalizeString(manufacturerVal);
      const modelSlug        = this.normalizeString(
        this.$model.find("option:selected").text()
      );

         if ( !year ) {
            await this.onModelChange();
            return;
         }


      this.updateURL(manufacturerSlug, modelSlug, year || null);
      this.$content.addClass('is-loading');

      const data = await this.fetchRest('vehicle', {
        brand: manufacturerVal,
        model: modelVal,
        year:  year,
      });

      if (!data) return;

      this.swapFragment(data);
      this.$content.removeClass('is-loading');
    }

    // -------------------------------------------------------------------------
    // Bind
    // -------------------------------------------------------------------------

    bindEvents() {
      this.$manufacturer.on("change", () => this.onManufacturerChange());
      this.$model.on("change",        () => this.onModelChange());
      this.$year.on("change",         () => this.onYearChange());
    }
  }
  new CarInfoFinder();
});


